import React, { useState, useEffect, useRef } from 'react';
import KpointPlayer from '../../components/Player/KpointPlayer';
import * as styles from './casestudyDiy.module.css';
import PersonalizationInfo from '../case-study/components/Personalization/index';
import AnalyticsThumbnail from '../case-study/components/Analytics/index';
import Tags from '../case-study/components/Tags';
import Seo from '../../components/seo.js';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import Footer from '../../components/layout/Footer/Footer.jsx';
import SimilarVideos from '../case-study/components/SimilarVideos/index';
import './casestudy.css';
import { useAuth } from '../../context/AuthContext';
import EmbeddedCasestudyVideoListing from '../../constants/CasestudyVideoListing';

const CasestudyDiy = () => {
  const { role } = useAuth(); // Get the user role
  const [activeVideo, setActiveVideo] = useState(null);
  const containerRef = useRef(null);
  const [selectedTag, setSelectedTag] = useState(null);
  const defaultPersonalizationInfo = {
    name: 'Saloni',
    policyNo: '12345',
    ActionButtonlabel: 'Buy Now',
    ActionButtonlabel1: 'Call Rm',
    ActionButtonlabel2: 'Join Us',
    ActionButtonlabel3: 'Chat with RM',
    Branching1: 'connectivity issue',
    Branching2: 'sound',
    Branching3: 'Battery',
    logo: 'https://www.hdfclife.com/content/dam/hdfclifeinsurancecompany/HDFC_logo.svg',
  };

  const playerRef = useRef(null);
  const location = useLocation(); // Use useLocation hook to get location

  const filteredVideos = EmbeddedCasestudyVideoListing.filter(video =>
    role === 'viewer' ? video.visibility === 'public' : true
  ).filter(video => !video.externalUrl);

  useEffect(() => {
    if (location) {
      const searchParams = new URLSearchParams(location.search);
      const videoId = searchParams.get('videoId');
      const lang = searchParams.get('lang');
      // Some entries share a videoId (e.g. English/Hindi variants of the same
      // package) and are only distinguished by `lang` - match on both when a
      // lang is present in the URL, otherwise fall back to the old
      // videoId-only match so existing links keep working.
      const foundVideo =
        (lang &&
          filteredVideos.find(
            video => video.videoId === videoId && video.lang === lang
          )) ||
        filteredVideos.find(video => video.videoId === videoId) ||
        filteredVideos[0];
      setActiveVideo(foundVideo);

      const tag = searchParams.get('tag');
      setSelectedTag(tag);
    }
  }, [location, filteredVideos]);

  // useEffect(() => {
  //   if (videoId) {
  //     const index = filteredVideos.findIndex(item => item.videoId === videoId);
  //     if (index !== -1) {
  //       setActiveVideo(filteredVideos[index]);
  //     }
  //   }
  // }, [videoId, filteredVideos]);

  if (!activeVideo) return null;

  const activePersonalizationInfo = {
    ...defaultPersonalizationInfo,
    ...activeVideo.personalizationInfo,
  };

  const scrollToTop = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const currentVideoIndex = () =>
    filteredVideos.findIndex(video =>
      activeVideo.lang
        ? video.videoId === activeVideo.videoId && video.lang === activeVideo.lang
        : video.videoId === activeVideo.videoId
    );

  const navigateToVideo = video => {
    const langParam = video.lang ? `&lang=${video.lang}` : '';
    navigate(`/casestudy/?videoId=${video.videoId}${langParam}`);
  };

  const handleNext = () => {
    const currentIndex = currentVideoIndex();
    const nextIndex = (currentIndex + 1) % filteredVideos.length;
    navigateToVideo(filteredVideos[nextIndex]);
    scrollToTop();
  };

  const handlePrevious = () => {
    const currentIndex = currentVideoIndex();
    const previousIndex =
      (currentIndex - 1 + filteredVideos.length) % filteredVideos.length;
    navigateToVideo(filteredVideos[previousIndex]);
    scrollToTop();
  };

  const handleTagClick = tag => {
    setSelectedTag(tag);
    navigate(`/case-study/?tag=${encodeURIComponent(tag)}`);
  };

  return (
    <>
      <Seo title="Casestudy" />
      <div
        ref={containerRef}
        className={`${
          activeVideo && activeVideo.videoOrientation === 'vertical'
            ? styles.CasestudyContainerVertical
            : styles.CasestudyContainer
        }`}
      >
        <div
          className={`${
            activeVideo && activeVideo.videoOrientation === 'vertical'
              ? styles.casestudyDiyContainerVertical
              : styles.casestudyDiyContainer
          }`}
        >
          <div
            className={`${
              activeVideo && activeVideo.videoOrientation === 'vertical'
                ? styles.videoContainerVertical
                : styles.videoContainer
            }`}
          >
            <div
              className={`${
                activeVideo.tryItOut.includes('') &&
                activeVideo &&
                activeVideo.videoOrientation === 'vertical'
                  ? 'noTryItOut '
                  : ''
              }${
                activeVideo && activeVideo.videoOrientation === 'vertical'
                  ? 'casestudyVideoContainerVertical'
                  : 'casestudyVideoContainer'
              }`}
            >
              <KpointPlayer
                videoId={activeVideo.videoId}
                packageId={activeVideo.packageId}
                isVerticalVideo={activeVideo.videoOrientation === 'vertical'}
                host={activeVideo.host}
                ref={playerRef}
                params={{ autoplay: true, muted: false, loop: true }}
                personalizationInfo={activePersonalizationInfo}
                style={{ gridArea: '1 / 1 / 2 / 2' }}
              />

              <div className="descriptionsection casestudy-description-section">
                <div className="casestudy-video-text">
                  <div
                    className={`${
                      activeVideo && activeVideo.videoOrientation === 'vertical'
                        ? 'heading-text-vertical'
                        : 'heading-text'
                    }`}
                    id="headingText"
                  >
                    {activeVideo.title}
                  </div>
                </div>
                <div className="expandable-text-container">
                  <div
                    className={` ${
                      activeVideo && activeVideo.videoOrientation === 'vertical'
                        ? 'vertical-expandable-text'
                        : 'expandable-text'
                    }`}
                    id="videoDescription"
                  >
                    {activeVideo.description}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${
              activeVideo && activeVideo.videoOrientation === 'vertical'
                ? styles.personalizationSectionVertical
                : styles.personalizationSection
            }`}
          >
            <div
              className={`${
                activeVideo.tryItOut.includes('') && activeVideo
                  ? 'casestudyNoDiy '
                  : ''
              }
                            ${
                              activeVideo &&
                              activeVideo.videoOrientation === 'vertical'
                                ? styles.casestudyDiyVertical
                                : styles.casestudyDiy
                            }`}
            >
              <PersonalizationInfo
                video={activeVideo}
                playerRef={playerRef}
                defaultPersonalizationInfo={activePersonalizationInfo}
              />
              <AnalyticsThumbnail activeVideo={activeVideo} />
            </div>
            <div
              className={`${
                activeVideo && activeVideo.videoOrientation === 'vertical'
                  ? styles.tagsUsedVertical
                  : styles.tagsUsed
              }`}
            >
              <div className={styles.tagsHeading}>Tags</div>
              <div className={styles.tagsContainerPersonalization}>
                <Tags
                  EmbeddedCasestudyVideoListing={filteredVideos}
                  videoTags={activeVideo.tags}
                  onTagClick={handleTagClick}
                  activeTags={selectedTag ? [selectedTag] : []} // Pass selected tag to Tags component
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className={`${
            activeVideo && activeVideo.videoOrientation === 'vertical'
              ? styles.previousNextContainerVertical
              : styles.previousNextContainer
          }`}
        >
          <div
            className={`${
              activeVideo && activeVideo.videoOrientation === 'vertical'
                ? styles.previousNextVertical
                : styles.previousNext
            }`}
          >
            <div className={styles.previous} onClick={handlePrevious}>
              <img
                src="../../images/arrow-circle-left.svg"
                className={styles.prevArrow}
              />
              <div className={styles.previousArrow}>Previous</div>
            </div>
            <div className={styles.next} onClick={handleNext}>
              <div className={styles.nextArrow}>Next</div>
              <img
                src="../../images/arrow-circle-right.svg"
                className={styles.nexArrow}
              />
            </div>
          </div>
        </div>
        <div className={styles.similarVideos}>
          <span className={styles.similarVideosHeading}>Similar Videos</span>
          <div className={styles.similarVideosContainer}>
            {activeVideo.tags && (
              <SimilarVideos
                activeTags={activeVideo.tags}
                videoId={activeVideo.videoId}
                lang={activeVideo.lang}
                containerRef={containerRef}
              />
            )}
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default CasestudyDiy;
